import { render } from "./AboutUs.vue?vue&type=template&id=1ab1a4c1&scoped=true&ts=true"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"

import "./AboutUs.vue?vue&type=style&index=0&id=1ab1a4c1&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab1a4c1"]])

export default __exports__